<g-flex
  height="50vh"
  justifyContent="center"
  alignItems="center">
  <g-loader
    class="full-page-loader-item"
    type="dark">
  </g-loader>
</g-flex>
